// Common animation setup function
function setupModalAnimation(config) {
    let button = document.querySelector(config.buttonClass);
    let comp = document.querySelector(config.compClass);
    let background = comp?.querySelector(config.backgroundClass);
    let wrap = comp?.querySelector(config.wrapClass);
    let close = comp?.querySelector(config.closeClass);

    if (!comp || !button) return;

    let openAnimation = gsap.timeline({ paused: true });
    openAnimation
        .set(comp, {
            display: "flex",
        })
        .from(background, {
            backgroundColor: "rgba(0, 0, 0, 0)",
            duration: 0.25,
        })
        .from(
            wrap,
            {
                opacity: 0,
                ease: "power2.inOut",
                duration: 0.5,
            },
            "<"
        )
        .fromTo(
            close,
            {
                scale: 0,
            },
            {
                scale: 1,
            },
            "<"
        );

    // Event listeners
    button.addEventListener("click", () => {
        openAnimation.play();
    });

    close.addEventListener("click", () => {
        openAnimation.reverse();
    });

    background.addEventListener("click", () => {
        openAnimation.reverse();
    });
}

// Setup shipping animation
setupModalAnimation({
    buttonClass: ".is--shipping-text",
    compClass: ".shipping_comp",
    backgroundClass: ".shipping_background",
    wrapClass: ".shipping_wrap",
    closeClass: ".shipping_close"
});

// Setup pickup animation
setupModalAnimation({
    buttonClass: ".is--pickup-text",
    compClass: ".pickup_comp",
    backgroundClass: ".pickup_background",
    wrapClass: ".pickup_wrap",
    closeClass: ".pickup_close"
});